import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
axios.interceptors.request.use(function (config) {
	const token = localStorage.getItem('token');
	if (token) {
		config.headers.Authorization = 'Bearer ' + token;
	}

	return config;
});
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

//Vee validate
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import * as rules from 'vee-validate/dist/rules';
Object.keys(rules).forEach((rule) => {
	extend(rule, rules[rule]);
});
localize('es', es);
// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Agregamos la URL base de nuestra API
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ?
	'https://makita.com.mx/garantiaextendida/api/' : // //https://rcreativo.com/garantiaextendida/api/
	'http://localhost/web/makita/garantiaextendida/api/';
	//'http://localhost:8888/garantiasmakita/garantiaextendida/api/';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

import PaperDashboard from './plugins/paperDashboard';
Vue.use(PaperDashboard);

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
